package br.com.htms.inspeccaocampo.ui.dashboards

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.widthIn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.efetivo.Datas
import br.com.htms.inspeccaocampo.data.efetivo.EfetivoDados
import br.com.htms.inspeccaocampo.data.efetivo.FolgaStatus
import br.com.htms.inspeccaocampo.data.efetivo.FuncEfetivo
import br.com.htms.inspeccaocampo.data.efetivo.RegrasEfetivo
import br.com.htms.inspeccaocampo.data.efetivo.TiposDia
import br.com.htms.inspeccaocampo.ui.kit.ChipFiltro
import br.com.htms.inspeccaocampo.ui.kit.CoresDash
import br.com.htms.inspeccaocampo.ui.kit.FatiaDash
import br.com.htms.inspeccaocampo.ui.kit.FiltrosAtivos
import br.com.htms.inspeccaocampo.ui.kit.FmtDash
import br.com.htms.inspeccaocampo.ui.kit.GradeKpis
import br.com.htms.inspeccaocampo.ui.kit.GraficoColunas
import br.com.htms.inspeccaocampo.ui.kit.GraficoRosca
import br.com.htms.inspeccaocampo.ui.kit.ItemPainel
import br.com.htms.inspeccaocampo.ui.kit.KpiDash
import br.com.htms.inspeccaocampo.ui.kit.PainelDashboard
import br.com.htms.inspeccaocampo.ui.kit.PaineisDoDash
import br.com.htms.inspeccaocampo.ui.kit.RankingBarras
import br.com.htms.inspeccaocampo.ui.kit.Seletor
import br.com.htms.inspeccaocampo.ui.kit.SemDadosDash
import br.com.htms.inspeccaocampo.ui.kit.SerieDash
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row

private val CorTipoDia = mapOf(
    TiposDia.TRABALHO to Color(0xFF1B7F3B),
    "folga" to Color(0xFF1E5AA8),
    "descanso_semanal" to Color(0xFF4F8FD8),
    "ferias" to Color(0xFF6A4FB3),
    "afastamento" to Color(0xFFE07B00),
    "falta" to Color(0xFFC62828),
    "feriado" to Color(0xFF8A94A6)
)

private val RotuloFolga = mapOf(
    FolgaStatus.EM_DIA to ("Em dia" to CoresDash.bom),
    FolgaStatus.PROXIMA to ("Próxima (até 7 dias)" to CoresDash.atencao),
    FolgaStatus.ADIADA to ("Adiada (fim de ano)" to Color(0xFF6A4FB3)),
    FolgaStatus.ATRASADA to ("Atrasada" to CoresDash.ruim),
    FolgaStatus.SEM_DATA to ("Sem data" to CoresDash.neutro)
)

@Composable
fun DashboardEfetivo(d: EfetivoDados, carregando: Boolean = false, onAtualizar: (() -> Unit)? = null) {
    var cc by remember { mutableStateOf("") }
    var dias by remember { mutableStateOf(30) }
    var fTipo by remember { mutableStateOf<String?>(null) }
    var fFuncao by remember { mutableStateOf<String?>(null) }
    val ref = d.hoje

    fun obraDe(f: FuncEfetivo, data: String) = RegrasEfetivo.obraEm(f.aloc, data) ?: RegrasEfetivo.SEM_OBRA
    fun nomeObra(id: String) = if (id == RegrasEfetivo.SEM_OBRA) "Sem obra" else d.centros.firstOrNull { it.id == id }?.rotulo ?: id

    val ativosHoje = d.funcionarios.filter { it.noQuadro(ref) }
    val afastCadastro = d.funcionarios.count {
        it.afastadoCadastro() && !it.desativadoCadastro() && (cc.isBlank() || obraDe(it, ref) == cc)
    }
    val daObra = ativosHoje.filter { cc.isBlank() || obraDe(it, ref) == cc }
    val filtrados = daObra.filter { (fTipo == null || RegrasEfetivo.tipoDia(it, ref) == fTipo) && (fFuncao == null || it.funcaoOuSem == fFuncao) }
    val porTipo = daObra.groupingBy { RegrasEfetivo.tipoDia(it, ref) }.eachCount()
    val trabalhando = porTipo[TiposDia.TRABALHO] ?: 0
    val transfAbertas = d.transferencias.count { it.aberta && (cc.isBlank() || it.origem == cc || it.destino == cc) }
    val semObra = ativosHoje.count { obraDe(it, ref) == RegrasEfetivo.SEM_OBRA }

    val filtrosAtivos = buildList {
        fTipo?.let { add("Hoje: ${TiposDia.rotulo(it)}" to { fTipo = null }) }
        fFuncao?.let { add("Função: $it" to { fFuncao = null }) }
    }

    PainelDashboard(
        titulo = "Dashboard — Efetivo",
        subtitulo = "Situação em ${Datas.br(ref)}" + (if (cc.isNotBlank()) " · ${nomeObra(cc)}" else " · todas as obras"),
        carregando = carregando,
        onAtualizar = onAtualizar,
        camposCor = listOf(
            "Trabalhando" to 0xFF1B7F3B,
            "Ausentes" to 0xFFB0BEC5,
            "Previsto" to 0xFFB0BEC5,
            "Alocado" to 0xFF1565C0,
            "Folga / descanso" to 0xFF1565C0,
            "Férias" to 0xFF6A4FB3,
            "Afastados / faltas" to 0xFFE0A000,
            "Sem obra" to 0xFFC62828
        ),
        filtros = {
            Row(horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                Box(Modifier.widthIn(min = 240.dp, max = 460.dp)) {
                    Seletor(
                        "Obra / centro de custo",
                        listOf("" to "Todas as obras") + d.centros.filter { it.ativo }.map { it.id to it.rotulo },
                        cc, { cc = it }
                    )
                }
            }
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                listOf(14, 30, 60).forEach { n -> ChipFiltro("Presença: $n dias", dias == n) { dias = n } }
            }
            FiltrosAtivos(filtrosAtivos) { fTipo = null; fFuncao = null }
        }
    ) { largo, grande ->
        if (d.funcionarios.isEmpty()) {
            SemDadosDash("Sem efetivo", "Nenhum funcionário cadastrado no Efetivo.")
            return@PainelDashboard
        }
        PaineisDoDash("efetivo", largo, organizar = !grande, itens = listOf(
            ItemPainel("kpis", "Indicadores", inteiro = true, conteudo = {
                GradeKpis(
            largo,
            listOf(
                { m -> KpiDash("Efetivo ativo", FmtDash.qtd(daObra.size), m, legenda = "previsto: ${FmtDash.qtd(d.previsto.filter { cc.isBlank() || it.cc == cc }.sumOf { it.qtd })}") },
                { m -> KpiDash("Trabalhando hoje", FmtDash.qtd(trabalhando), m, cor = CoresDash.bom, legenda = FmtDash.pct(if (daObra.isEmpty()) null else trabalhando.toDouble() / daObra.size) + " do efetivo") },
                { m -> KpiDash("Folga / descanso", FmtDash.qtd((porTipo["folga"] ?: 0) + (porTipo["descanso_semanal"] ?: 0)), m, cor = PortalCores.AzulIcone) },
                { m -> KpiDash("Férias", FmtDash.qtd(porTipo["ferias"] ?: 0), m, cor = Color(0xFF6A4FB3)) },
                { m -> KpiDash("Afastados / faltas", FmtDash.qtd((porTipo["afastamento"] ?: 0) + (porTipo["falta"] ?: 0) + afastCadastro), m, cor = CoresDash.atencao, legenda = "cadastro: $afastCadastro · faltas: ${porTipo["falta"] ?: 0}") },
                { m -> KpiDash("Sem obra", FmtDash.qtd(semObra), m, cor = if (semObra > 0) CoresDash.ruim else CoresDash.bom, destaque = semObra > 0) },
                { m -> KpiDash("Transferências pendentes", FmtDash.qtd(transfAbertas), m, cor = if (transfAbertas > 0) CoresDash.atencao else CoresDash.bom) }
            )
        )
            }),
            ItemPainel("situacao", "Situação hoje") { m ->
                GraficoRosca(
                    "Situação hoje", "Clique para filtrar",
                    porTipo.entries.sortedByDescending { it.value }.map { (t, n) -> FatiaDash(TiposDia.rotulo(t), n.toDouble(), CorTipoDia[t] ?: CoresDash.neutro) },
                    m, grande, rotuloTotal = "pessoas",
                    selecionada = fTipo?.let { TiposDia.rotulo(it) },
                    onClick = { r -> val t = TiposDia.todos.firstOrNull { it.second == r }?.first; fTipo = if (t == null || fTipo == t) null else t }
                )
            },
            ItemPainel("folgas", "Controle de folgas") { m ->
                val st = filtrados.groupingBy { RegrasEfetivo.folgaStatus(it, ref).status }.eachCount()
                GraficoRosca(
                    "Controle de folgas", "Dias corridos sem folga x regime",
                    RotuloFolga.mapNotNull { (k, v) -> st[k]?.let { FatiaDash(v.first, it.toDouble(), v.second) } },
                    m, grande, rotuloTotal = "pessoas"
                )
            },
            ItemPainel("presenca", "Presença diária", inteiro = true) {
        val presenca = remember(d, cc, dias) {
            val datas = (dias - 1 downTo 0).map { Datas.add(ref, -it) }
            datas.map { dia ->
                val ativos = d.funcionarios.filter { it.noQuadro(dia) && (cc.isBlank() || obraDe(it, dia) == cc) }
                val t = ativos.count { RegrasEfetivo.tipoDia(it, dia) == TiposDia.TRABALHO }
                Triple(dia, t.toDouble(), (ativos.size - t).toDouble())
            }
        }
        GraficoColunas(
            "Presença diária — últimos $dias dias", "Pessoas trabalhando e ausentes (folga, férias, afastamento, falta)",
            presenca.map { it.first.substring(8, 10) + "/" + it.first.substring(5, 7) },
            listOf(
                SerieDash("Trabalhando", CoresDash.de("Trabalhando", 0xFF1B7F3B), presenca.map { it.second }),
                SerieDash("Ausentes", CoresDash.de("Ausentes", 0xFFB0BEC5), presenca.map { it.third })
            ),
            grande = grande, fmt = { FmtDash.qtd(it) }
        )
            },
            ItemPainel("alocado", "Previsto x alocado por obra") { m ->
                val obras = (d.previsto.map { it.cc } + ativosHoje.map { obraDe(it, ref) }).distinct()
                    .filter { cc.isBlank() || it == cc }
                    .sortedByDescending { o -> ativosHoje.count { obraDe(it, ref) == o } }
                GraficoColunas(
                    "Previsto x alocado por obra", "Efetivo previsto no planejamento e alocado hoje",
                    obras.map { o -> if (o == RegrasEfetivo.SEM_OBRA) "Sem obra" else d.centros.firstOrNull { it.id == o }?.codigo ?: o },
                    listOf(
                        SerieDash("Previsto", CoresDash.de("Previsto", 0xFFB0BEC5), obras.map { o -> d.previsto.filter { it.cc == o }.sumOf { it.qtd }.toDouble() }),
                        SerieDash("Alocado", CoresDash.de("Alocado", 0xFF1565C0), obras.map { o -> ativosHoje.count { obraDe(it, ref) == o }.toDouble() })
                    ),
                    m, grande, fmt = { FmtDash.qtd(it) }, empilhado = false,
                    onClick = { i -> obras.getOrNull(i)?.let { o -> cc = if (cc == o || o == RegrasEfetivo.SEM_OBRA) "" else o } }
                )
            },
            ItemPainel("por-obra", "Efetivo por obra") { m ->
                RankingBarras(
                    "Efetivo por obra", "Alocados hoje · clique para filtrar",
                    contagem(ativosHoje) { nomeObra(obraDe(it, ref)) }, m,
                    selecionado = if (cc.isBlank()) null else nomeObra(cc),
                    onClick = { r -> val id = d.centros.firstOrNull { it.rotulo == r }?.id.orEmpty(); cc = if (cc == id) "" else id }
                )
            },
            ItemPainel("funcao", "Por função") { m ->
                RankingBarras("Por função", "Clique para filtrar", contagem(daObra) { it.funcaoOuSem }, m, cor = CoresDash.cor(3), limite = 12, selecionado = fFuncao, onClick = { fFuncao = alternar(fFuncao, it) })
            },
            ItemPainel("vinculo", "Por vínculo") { m ->
                RankingBarras("Por vínculo", "Efetivo ativo", contagem(filtrados) { it.vinculo.ifBlank { "Não informado" } }, m, cor = CoresDash.cor(5))
            }
        ))
    }
}

private val FuncEfetivo.funcaoOuSem: String get() = funcao.ifBlank { "Sem função" }
